import React from 'react';

export function sideCellRenderer(props: { value: unknown }) {
    return (
        <div className="order-side">
            <div className={`order-side-${props.value}`}>
                <>{props.value}</>
            </div>
        </div>
    );
}
